import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import hoistNonReactStatics from 'hoist-non-react-statics';
import { forwardRef } from 'react';
import { setDisplayName, wrapDisplayName } from 'recompose';
import { usePermissionForRule } from 'hooks/permissions/use-permission';
export const withHideIfNotAllowed = (Component)=>{
    // eslint-disable-next-line react/display-name
    const Next = /*#__PURE__*/ forwardRef(({ ruleName, ...props }, ref)=>{
        const { isAllowedForCurrentUser } = usePermissionForRule();
        return ruleName == null || isAllowedForCurrentUser(ruleName) ? /*#__PURE__*/ _jsx(Component, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ _jsx(_Fragment, {});
    });
    return setDisplayName(wrapDisplayName(Component, 'withHideIfNotAllowed'))(hoistNonReactStatics(Next, Component));
};
export const HideIfNotAllowed = ({ ruleName, children })=>{
    const { isAllowedForCurrentUser } = usePermissionForRule();
    return isAllowedForCurrentUser(ruleName) ? /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    }) : /*#__PURE__*/ _jsx(_Fragment, {});
};
export const SwitchContentBasedOnAccess = ({ ruleName, hasAccess, doesNotHaveAccess })=>{
    const { isAllowedForCurrentUser } = usePermissionForRule();
    return isAllowedForCurrentUser(ruleName) ? hasAccess : doesNotHaveAccess;
};
